import { render } from "./FavoritesFolderNameInputDialog.vue?vue&type=template&id=0bd754cc&scoped=true&ts=true"
import script from "./FavoritesFolderNameInputDialog.vue?vue&type=script&lang=ts"
export * from "./FavoritesFolderNameInputDialog.vue?vue&type=script&lang=ts"

import "./FavoritesFolderNameInputDialog.vue?vue&type=style&index=0&id=0bd754cc&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd754cc"]])

export default __exports__